var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "d-block",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "v-alert",
            {
              staticClass: "mb-0",
              attrs: {
                type: "error",
                color: "error lighten-1"
              }
            },
            [_vm._v(" ACCOUNT RESTRICTED - " + _vm._s(_vm.banReason) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }